import React, { useRef } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';

interface ConfettiProps
  extends Readonly<{
    isSuccess?: boolean;
  }> {}

export const Confetti: React.FC<ConfettiProps> = ({ isSuccess = false }) => {
  const lottieRef = useRef(null);
  const isMobile = useIsMobileScreen();

  return (
    <Player
      onEvent={event => {
        if (event === 'complete') {
          const player = lottieRef?.current as unknown as Player;
          player?.container?.remove();
        }
      }}
      ref={lottieRef}
      autoplay
      keepLastFrame
      src="https://d2uft7zh7kxc3y.cloudfront.net/rsvp_confetti.json"
      style={{ position: 'absolute', width: isMobile ? `calc(100% - ${isSuccess ? '48px' : '0'})` : '540px', top: isMobile ? '0' : '-64px', left: 0, right: 0 }}
    />
  );
};
